import { ChakraV3 } from '@piccolohealth/ui';
import type { Duration } from '@piccolohealth/util';
import React from 'react';

export interface DurationInputProps {
  value: Duration;
  onChange: (value: Duration) => void;
}

export const DurationInput = (props: DurationInputProps) => {
  const rescaled = React.useMemo(() => {
    return props.value.rescale();
  }, [props.value]);

  const onChange = (field: 'hours' | 'minutes' | 'seconds', value: number) => {
    const newValue = value < 0 || Number.isNaN(value) ? 0 : value;

    if (field === 'hours' && newValue > 23) {
      return;
    }

    if (field === 'minutes' && newValue > 59) {
      return;
    }

    if (field === 'seconds' && newValue > 59) {
      return;
    }

    props.onChange(rescaled.set({ [field]: newValue }).rescale());
  };

  const hours = rescaled.get('hours').toString();
  const minutes = rescaled.get('minutes').toString();
  const seconds = rescaled.get('seconds').toString();

  return (
    <ChakraV3.HStack>
      <ChakraV3.NumberInput.Root
        colorPalette='brand'
        value={hours}
        onValueChange={({ valueAsNumber }) => onChange('hours', valueAsNumber)}
        size='sm'
        clampValueOnBlur
        allowOverflow={false}
      >
        <ChakraV3.NumberInput.Control />
        <ChakraV3.InputGroup w='full' endElement={<ChakraV3.Text w='40px'>hr</ChakraV3.Text>}>
          <ChakraV3.NumberInput.Input />
        </ChakraV3.InputGroup>
      </ChakraV3.NumberInput.Root>

      <ChakraV3.NumberInput.Root
        colorPalette='brand'
        value={minutes}
        onValueChange={({ valueAsNumber }) => onChange('minutes', valueAsNumber)}
        size='sm'
        clampValueOnBlur
        allowOverflow={false}
      >
        <ChakraV3.NumberInput.Control />
        <ChakraV3.InputGroup w='full' endElement={<ChakraV3.Text w='40px'>min</ChakraV3.Text>}>
          <ChakraV3.NumberInput.Input />
        </ChakraV3.InputGroup>
      </ChakraV3.NumberInput.Root>

      <ChakraV3.NumberInput.Root
        colorPalette='brand'
        value={seconds}
        onValueChange={({ valueAsNumber }) => onChange('seconds', valueAsNumber)}
        size='sm'
        clampValueOnBlur
        allowOverflow={false}
      >
        <ChakraV3.NumberInput.Control />
        <ChakraV3.InputGroup w='full' endElement={<ChakraV3.Text w='40px'>sec</ChakraV3.Text>}>
          <ChakraV3.NumberInput.Input />
        </ChakraV3.InputGroup>
      </ChakraV3.NumberInput.Root>
    </ChakraV3.HStack>
  );
};
